import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import RankingSection from './components/RankingSection';
import FeaturedSection from './components/FeaturedSection';
import StatsSection from './components/StatsSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫之家',
    url: 'https://www.hanmanzhijia.com',
    description: '韩漫之家作为海量正版漫画的在线阅读平台，提供免费的韩国漫画大全。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.hanmanzhijia.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫之家',
    url: 'https://www.hanmanzhijia.com',
    description: '韩漫之家-免费漫画-海量正版漫画在线阅读平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6688',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '北京',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotRecommend />
          <LatestUpdate />
          <RankingSection />
          <FeaturedSection />
          <StatsSection />
        </main>
        <Footer />
      </div>
    </>
  );
}